import { useState, useEffect } from "react";
import { 
    Button, 
    Grid, 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    TextField, 
    Switch, 
    FormControlLabel,
    InputAdornment
} from "@material-ui/core"
import { useFormik } from "formik"
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck";
import { 
    editarVueloAction, 
    obtenerCatalogoProveedorAereoAction, 
    obtenerVuelosPorCircuitoAction 
} from "../../../ducks/proveedorAereolineaDuck";
import useApi from "../../../hooks/useAPI";
import { esFechaValida, FormatoFechaIso } from "../../../utils/FormatFecha";
import { ToastMessage } from "../../../global/ToastMessage";
import ModalBase from "../../../global/ModalBase";
import HeaderModal from "../../../global/headerModal";
import AutoInputIATA from "../AutoInputIATA";
import PickerModHora from "../../../global/PickersModHora";
import EditIcon from '@material-ui/icons/Edit';
import { FAProvedoresVuelosStyle } from "./styles";
import ExtrasCheckboxes, { convertExtrasToHTML, normalizarExtras, parseExtrasFromHTML } from "../ExtrasCheckboxes/ExtrasCheckboxes";
import useCatalogos from "../../../hooks/useCatalogos";

const useCatalogoPrveedoresAereos = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCatalogoProveedorAereoAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const useObtenerVuelosPorCircuito = (circuito) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerVuelosPorCircuitoAction({ idPaqueteCircuito: circuito?.IdPaqueteCircuito })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, circuito])
}

const normalizarFecha = (fecha) => {
    return new Date(fecha).toISOString(); // Convierte cualquier formato a ISO
};

const validationSchema = yup.object({
    claveVuelo: yup
        .string("Ingrese una clave vuelo")
        .required("Es requerido"),
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    disponibilidad: yup
        .number("Ingresa un numero")
        .positive("Numero positivo")
        .required("Es requerido"),
    claveVueloRedondo: yup
        .string("Ingrese una clave vuelo")
})


const FAProveedoresVuelos = ({ vuelo }) => {
    const initialValues = {
        monto: vuelo?.PrecioNeto || 0,
        claveVuelo: vuelo?.ClaveVuelo || "",
        regionVuelo: vuelo?.CatRegion?.IdCatRegion || 0,
        disponibilidad: vuelo?.Disponibilidad || 0,
        claveVueloRedondo: vuelo?.VueloRedondo?.ClaveVuelo || "No aplica",
    };

    const dispatch = useDispatch()
    const classes = FAProvedoresVuelosStyle();
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const catalogoClases = useCatalogos("Flight/Class")
    const catalogoVuelo = useCatalogos("Flight/Includes");

    const [open, setOpen] = useState(false)
    // const [value, setValue] = useState(0)
    const [idProveedor, setIdProveedor] = useState(0)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [claseVuelo, setClaseVuelo] = useState(0)
    const [claseVueloRedondo, setClaseVueloRedondo] = useState(0)
    const [regionVuelo, setRegionVuelo] = useState(0)
    const [isRedondo, setIsRedondo] = useState(false)

    const [itinerario, setItenerario] = useState('<p><strong>Escribe aqui el itinerario</strong></p>')
    const [incluye, setIncluye] = useState('<p><strong>Escribe aqui lo que incluye</strong></p>')
    const [noIncluye, setNoIncluye] = useState('<p><strong>Escribe aqui lo que No Incluye</strong></p>')
    const [selectedExtras, setSelectedExtras] = useState([]);

    const [destino, setDestino] = useState({ IdCodigo: 0 })
    const [origen, setOrigen] = useState({ IdCodigo: 0 })
    const [destinoRegreso, setDestinoRegreso] = useState({ IdCodigo: 0 })
    const [origenRegreso, setOrigenRegreso] = useState({ IdCodigo: 0 })
    const [isActive, setIsActive] = useState(vuelo?.Estatus)

    const [detallesDeVuelo, setDetallesDeVuelo] = useState({ 
        fechaSalida: new Date(),
        fechaLlegada: new Date(),
        fechaSalidaRedondo: new Date(),
        fechaLlegadaRedondo: new Date(),
    })

    const { circuitoSelect } = useSelector(store => store.proveedorTerrestre);
    const { catalogoProvAereo } = useSelector(store => store.vueloProveedor)

    const normalizedExtras = normalizarExtras(catalogoVuelo);

    useCatalogoPrveedoresAereos()
    useObtenerVuelosPorCircuito(circuitoSelect)

    useEffect(() => {
        if (vuelo) {
            formik.setFieldValue("monto", vuelo.PrecioNeto)
            formik.setFieldValue("claveVuelo", vuelo.ClaveVuelo)
            formik.setFieldValue("regionVuelo", vuelo.CatRegion?.IdCatRegion)
            formik.setFieldValue("disponibilidad", vuelo.Disponibilidad)
            formik.setFieldValue("claveVueloRedondo", vuelo.VueloRedondo?.ClaveVuelo)
            setIdProveedor(vuelo.Proveedor.IdProveedor)
            setTipoMoneda(vuelo.Moneda.id_moneda)
            setRegionVuelo(vuelo.CatRegion?.IdCatRegion)
            setIsRedondo(vuelo.EsRedondo)

            setDestino(vuelo.Destino)
            setOrigen(vuelo.Origen)
            setDestinoRegreso(vuelo.VueloRedondo?.Destino)
            setOrigenRegreso(vuelo.VueloRedondo?.Origen)
            setClaseVuelo(vuelo.CatVueloClase?.IdCatVueloClase)
            setClaseVueloRedondo(vuelo.VueloRedondo?.CatVueloClase ? vuelo.VueloRedondo?.CatVueloClase?.IdCatVueloClase : '')

            setItenerario(vuelo.Itinerario)
            setIncluye(vuelo.Incluye)
            setNoIncluye(vuelo.NoIncluye)

            const selectedExtrasIds = 
                vuelo?.lIncluye.length > 0
                    ? vuelo?.lIncluye?.map(item => item.IdCatVueloAditamento)
                    : parseExtrasFromHTML(vuelo.Incluye, normalizedExtras);
            
            setSelectedExtras(selectedExtrasIds);

            setDetallesDeVuelo({
                fechaLlegada: FormatoFechaIso({ date: vuelo.FechaLlegada, formato: "yyyy-MM-dd HH:MM" }),
                fechaSalida: FormatoFechaIso({ date: vuelo.FechaSalida, formato: "yyyy-MM-dd HH:MM" }),
                fechaLlegadaRedondo: FormatoFechaIso({ date: vuelo.VueloRedondo?.FechaLlegada, formato: "yyyy-MM-dd HH:MM" }),
                fechaSalidaRedondo: FormatoFechaIso({ date: vuelo.VueloRedondo?.FechaSalida, formato: "yyyy-MM-dd HH:MM" }),
            })

        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vuelo])


    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }
    const handleSelecProveedor = (event) => {
        setIdProveedor(event.target.value)
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    const handleSelecRegionVuelo = (event) => {
        setRegionVuelo(event.target.value)
    }
    const handleSelectClaseVuelo = (event) => {
        setClaseVuelo(event.target.value)
    }
    const handleSelectClaseVueloRedondo = (event) => {
        setClaseVueloRedondo(event.target.value)
    }
    // Manejar los estados de los campos de fecha
    const handleStateChange = (field, value) => {
        setDetallesDeVuelo((prev) => ({ ...prev, [field]: value }));
    };
    const handleClickSelecFecha = (field, date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        handleStateChange(field, date)
    }
    const handleChangeIsRedondo = (event) => {
        let redondo = event.target.checked
        setIsRedondo(redondo)
        if (redondo) {
            formik.setFieldValue("claveVueloRedondo", "")
        } else {
            formik.setFieldValue("claveVueloRedondo", "No aplica")
        }
    }

    const onSave = async (values) => {
        try {
          if (tipoMoneda === 0) {
            ToastMessage.fire({
              icon: "warning",
              title: "Selecciona una moneda válida",
            });
            return;
          }
      
          if (idProveedor === 0) {
            ToastMessage.fire({
              icon: "warning",
              title: "Selecciona un proveedor válido",
            });
            return;
          }
      
          // Activar loading
          dispatch(onLoadAnction({ message: "Actualizando circuito..." }));
      
          const vueloReondo = {
            IdCatVueloClase: claseVueloRedondo,
            ClaveVuelo: values?.claveVueloRedondo,
            FechaSalida: normalizarFecha(detallesDeVuelo?.fechaSalidaRedondo),
            FechaLlegada: normalizarFecha(detallesDeVuelo?.fechaLlegadaRedondo),
            IdOrigen: origenRegreso?.IdCodigo,
            IdDestino: destinoRegreso?.IdCodigo,
          };
      
          const payload = {
            idVueloProveedor: vuelo?.IdVueloProveedor,
            idProveedor: vuelo?.Proveedor.IdProveedor,
            idCatVueloClase: claseVuelo,
            idCatRegion: regionVuelo,
            idMoneda: tipoMoneda,
            claveVuelo: values?.claveVuelo,
            precioNeto: Number(values?.monto),
            disponibilidad: values?.disponibilidad,
            fechaSalida: normalizarFecha(detallesDeVuelo?.fechaSalida),
            fechaLlegada: normalizarFecha(detallesDeVuelo?.fechaLlegada),
            idOrigen: origen?.IdCodigo,
            idDestino: destino?.IdCodigo,
            itinerario,
            incluye,
            noIncluye,
            esRedondo: isRedondo,
            estatus: isActive,
            vueloRedondo: vueloReondo,
            lCatIncluye: selectedExtras
          };
      
          // Enviar el payload y esperar respuesta
          const response = await dispatch(editarVueloAction(payload));
      
          // Manejar respuestas específicas
          if (response.status === 500) {
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema. Intenta más tarde.",
            });
            return;
          }
      
          if (response.status === 400) {
            ToastMessage.fire({
              icon: "warning",
              title: response.Message,
            });
            return;
          }
      
          // Actualizar la lista de vuelos después de guardar
          await dispatch(obtenerVuelosPorCircuitoAction({
            idPaqueteCircuito: circuitoSelect?.IdPaqueteCircuito,
          }));
      
          // Cerrar el modal o realizar acción posterior
          handleClose(true);
      
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso correcto",
          });
        } catch (error) {
          console.error("Error en onSave:", error);
      
          ToastMessage.fire({
            icon: "error",
            title: "Ocurrió un error inesperado",
          });
        } finally {
          // Asegurarse de que siempre apague el loading
          dispatch(offLoadAction());
        }
    };
      
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleOpen}>
                <EditIcon />
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose} style={{ overflow: "scroll" , height: "90%", margin: "5rem auto", display: "block"}}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Editar vuelo ${vuelo?.ClaveVuelo}`}
                />
                  
                <form onSubmit={formik.handleSubmit}>
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12}>
                            <Grid container className={classes.containerSpacing}>
                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="input-claveVuelo"
                                        label="Clave vuelo"
                                        type="text"
                                        variant="outlined"
                                        name="claveVuelo"
                                        value={formik.values.claveVuelo}
                                        onChange={formik.handleChange}
                                        error={formik.touched.claveVuelo && Boolean(formik.errors.claveVuelo)}
                                        helperText={formik.touched.claveVuelo && formik.errors.claveVuelo}
                                        className={classes.textField}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="input-disponibilidad-vuelo"
                                        label="Disponibilidad"
                                        type="text"
                                        variant="outlined"
                                        name="disponibilidad"
                                        value={formik.values.disponibilidad}
                                        onChange={formik.handleChange}
                                        error={formik.touched.disponibilidad && Boolean(formik.errors.disponibilidad)}
                                        helperText={formik.touched.disponibilidad && formik.errors.disponibilidad}
                                        className={classes.textField}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lTipoProveedorAereo">Proveedor aereo</InputLabel>
                                        <Select
                                            labelId="lTipoProveedorAereo"
                                            id="STipoProveedorAereo"
                                            name="proveedorAereo"
                                            value={idProveedor}
                                            onChange={handleSelecProveedor}
                                            label="Proveedor aereo"
                                        >
                                            <MenuItem value="0" disabled>
                                                {"Seleccione una opción"}
                                            </MenuItem>
                                            {catalogoProvAereo.map((item, index) => (
                                                <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                                                    {item.RazonSocial}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={4}>
                                    <AutoInputIATA
                                        label="Origen"
                                        name="Origen"
                                        setTarget={setOrigen}
                                        value={origen}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <AutoInputIATA
                                        label="Destino"
                                        name="destino"
                                        setTarget={setDestino}
                                        value={destino}
                                    />
                                </Grid>

                                <Grid item xs={4} sm={4}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lTipoRegion">Region</InputLabel>
                                        <Select
                                            labelId="lTipoRegion"
                                            id="STiporRegion"
                                            name="tiporRegion"
                                            value={regionVuelo}
                                            onChange={handleSelecRegionVuelo}
                                            label="Region"
                                            disabled={!circuitoSelect?.LPaqueteCircuitoRegion || circuitoSelect?.LPaqueteCircuitoRegion?.length <= 0}
                                        >
                                            <MenuItem value="0" disabled>
                                                {circuitoSelect?.LPaqueteCircuitoRegion && circuitoSelect?.LPaqueteCircuitoRegion?.length <= 0 
                                                    ? "No hay regiones asignadas"
                                                    : "Seleccione una region"
                                                }
                                            </MenuItem>
                                            {circuitoSelect?.LPaqueteCircuitoRegion
                                                ?.filter(region => region.IncluyeVuelo === true)
                                                .map((region, index) => (
                                                    <MenuItem key={region?.CatRegion.IdCatRegion} value={region?.CatRegion.IdCatRegion}>
                                                        {region?.CatRegion.Descripcion}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={4}>
                                    <PickerModHora
                                        id="fechaSalidaVuelo"
                                        label="Fecha de salida"
                                        selectedDate={detallesDeVuelo?.fechaSalida}
                                        setSelectedDate={(date) => {handleClickSelecFecha("fechaSalida", date)}}
                                        disablePast={true}
                                        disableFuture={false}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <PickerModHora
                                        id="fechaLlegadaVuelo"
                                        label="Fecha de llegada"
                                        selectedDate={detallesDeVuelo?.fechaLlegada}
                                        setSelectedDate={(date) => {handleClickSelecFecha("fechaLlegada", date)}}
                                        disablePast={true}
                                        disableFuture={false}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lClaseVuelo">Clase de vuelo</InputLabel>
                                        <Select
                                            labelId="lClaseVuelo"
                                            id="SClaseVuelo"
                                            name="claseVuelo"
                                            value={claseVuelo}
                                            onChange={handleSelectClaseVuelo}
                                            label="Moneda"
                                        >
                                            <MenuItem value="0" disabled>
                                                {"Seleccione una clase"}
                                            </MenuItem>
                                            {catalogoClases.map((clase, index) => (
                                                <MenuItem key={clase.IdCatVueloClase} value={clase.IdCatVueloClase}>
                                                     {clase.Descripcion}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="input-Monto"
                                        label="Monto"
                                        type="text"
                                        variant="outlined"
                                        name="monto"
                                        value={formik.values.monto}
                                        onChange={formik.handleChange}
                                        error={formik.touched.monto && Boolean(formik.errors.monto)}
                                        helperText={formik.touched.monto && formik.errors.monto}
                                        className={classes.textField}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    {vuelo?.Moneda?.Clave}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                
                                <Grid item xs={4}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                        <Select
                                            labelId="lTipoMoneda"
                                            id="STipoMoneda"
                                            name="tipoMoneda"
                                            value={tipoMoneda}
                                            onChange={handleSelecTipoMoneda}
                                            label="Moneda"
                                        >
                                            <MenuItem value="0" disabled>
                                                {"Seleccione una opción"}
                                            </MenuItem>
                                            {catalogoMoneda.map((moneda, index) => (
                                                <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                                    {`${moneda.Clave} - ${moneda.Descripcion}`}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={4} className={classes.containerSpacing} >
                                    <label style={{ fontWeight: 400, fontSize: "1rem"}}>
                                        Vuelo activo
                                    </label>
                                    <Switch
                                        name="checkedB"
                                        checked={isActive}
                                        onChange={() => setIsActive(!isActive)}
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </Grid>
                                
                            </Grid>
                        </Grid>
                       
                        <Grid container style={{ margin: "0.5rem 10px" }}>
                            <div style={{marginBottom: "0.5rem"}}>
                                <strong>Extras que puede incluir el vuelo</strong>
                            </div>
                            <ExtrasCheckboxes 
                                extrasList={normalizedExtras} 
                                selectedIds={selectedExtras}
                                onSelectionChange={(newIds) => {
                                    setSelectedExtras(newIds);

                                    // Opcional: mantener compatibilidad con strings HTML
                                    setIncluye(convertExtrasToHTML(newIds, normalizedExtras, true));
                                    setNoIncluye(convertExtrasToHTML(newIds, normalizedExtras, false));
                                }}
                            />
                        </Grid>
                                  
                        <Grid item xs={12}>
                            <Grid container className={classes.containerSpacing}>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isRedondo}
                                                onChange={handleChangeIsRedondo}
                                                name="hcekIsRedondo"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        }
                                        label="Es vuelo redondo"
                                        labelPlacement="start"
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <TextField
                                        required
                                        id="input-claveVueloRegreso"
                                        label="Clave vuelo redondo"
                                        type="text"
                                        variant="outlined"
                                        name="claveVueloRedondo"
                                        value={formik.values.claveVueloRedondo}
                                        onChange={formik.handleChange}
                                        error={formik.touched.claveVueloRedondo && Boolean(formik.errors.claveVueloRedondo)}
                                        helperText={formik.touched.claveVueloRedondo && formik.errors.claveVueloRedondo}
                                        className={classes.textField}
                                        disabled={!isRedondo}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <AutoInputIATA
                                        label="Origen regreso"
                                        name="OrigenRegreso"
                                        setTarget={setOrigenRegreso}
                                        value={origenRegreso}
                                        disabled={!isRedondo}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <AutoInputIATA
                                        label="Destino regreso"
                                        name="destinoRegreso"
                                        setTarget={setDestinoRegreso}
                                        value={destinoRegreso}
                                        disabled={!isRedondo}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="lClaseVueloRedondo">Clase de vuelo</InputLabel>
                                        <Select
                                            labelId="lClaseVueloRedondo"
                                            id="SClaseVueloRedondo"
                                            name="claseVueloRedondo"
                                            disabled={!isRedondo}
                                            value={claseVueloRedondo}
                                            onChange={handleSelectClaseVueloRedondo}
                                            label="Moneda"
                                        >
                                            <MenuItem value="0" disabled>
                                                {"Seleccione una clase"}
                                            </MenuItem>
                                            {catalogoClases.map((clase, index) => (
                                                <MenuItem key={clase.IdCatVueloClase} value={clase.IdCatVueloClase}>
                                                     {clase.Descripcion}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={4}>
                                    <PickerModHora
                                        id="fechaSalidaVueloRedondo"
                                        label="Fecha de salida vuelo redondo"
                                        selectedDate={detallesDeVuelo?.fechaSalidaRedondo}
                                        setSelectedDate={(date) => {handleClickSelecFecha("fechaSalidaRedondo", date)}}
                                        disablePast={true}
                                        disableFuture={false}
                                        disabled={!isRedondo}
                                    />
                                </Grid>

                                <Grid item xs={4}>
                                    <PickerModHora
                                        id="fechaRegresoVueloRedondo"
                                        label="Fecha de regreso vuelo redondo"
                                        selectedDate={detallesDeVuelo?.fechaLlegadaRedondo}
                                        setSelectedDate={(date) => {handleClickSelecFecha("fechaLlegadaRedondo", date)}}
                                        disablePast={true}
                                        disableFuture={false}
                                        disabled={!isRedondo}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container className={classes.containerSpacing}>
                       <Grid item xs={12} className={classes.modalBotonesCenter}>
                       <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Guardar cambios
                        </Button>
                        </Grid>
                    </Grid>
                </form>
            </ModalBase>
        </div>
    )
}
export default FAProveedoresVuelos;